import CustomNavbar from "../components/Navbar/CustomNavbar";
import Navbar from "../components/Navbar/Navbar";
import Posts from "../components/posts/Posts";

const PostsPage = () => {
    return (

        <>
        {/* <Navbar/> */}
        <CustomNavbar/>
        <Posts/>
        
        </>
      );
}
 
export default PostsPage;